import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './index.scss';

const MasterRange = ({ range: { rangeName, partOfLabel }, extendClass }) => (
    <div className={classNames({ [styles.MasterRange]: true, [extendClass]: extendClass })}>
        {partOfLabel} <b className={styles.boldArea}>{rangeName}</b>
    </div>
);

MasterRange.propTypes = {
    range: PropTypes.shape({
        rangeName: PropTypes.string.isRequired,
        partOfLabel: PropTypes.string,
    }).isRequired,
    extendClass: PropTypes.string,
};

export default MasterRange;
